(ns teamoesterreich.admin-mode.navigation.app-bar

  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.chevron-left :refer [chevron-left]]
            [reagent-material-ui.icons.chevron-right :refer [chevron-right]]
            [reagent-material-ui.icons.help :refer [help]]
            [reagent-material-ui.icons.link :refer [link]]
            [reagent-material-ui.icons.link-off :refer [link-off]]

            [reagent-material-ui.icons.menu :refer [menu]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.setup :as setup]
            [teamoesterreich.view-state :as vstate]
            ["react-oidc-context" :as roc]
            ["react" :as react]
            ))

(def ENV setup/config)

(defn logout-button [{:keys [onClose] :as props}]
  (let [auth (roc/useAuth)]
    [mui/menu-item {:onClick (fn []
                               (onClose)
                               (.signoutRedirect auth)
                               )}
     "Logout"]))

(defn drawer-button [{:keys [drawer-open on-toggle] :as props}]
  [mui/icon-button
   {:edge    "start" :class "" :aria-label "drawer-menu"
    :onClick on-toggle}
   (if drawer-open [chevron-left] [chevron-right])
   ])

(defn connected-icon [{:keys [connected]}]
  [mui/icon-button
   {:edge "end" :aria-label "link"}
   (if connected [link] [link-off])
   ])

(defn- _bar []
  (let [!menu-anchor (r/atom nil)
        set-anchor #(reset! !menu-anchor %)
        build-date (.-content (js/document.querySelector "meta[name=\"build-date\"]"))]
    (fn [{:keys [classes drawer-open toggle-drawer menu-open set-menu user site connected]}]
      [mui/app-bar
       {:position "static"
        :style    {:backgroundColor "#db021a"
                   :width           (if drawer-open "calc(100% - 240px)" "100%")
                   :marginLeft      (if drawer-open "240px" "0px")}}
       [mui/toolbar
        [drawer-button {:drawer-open drawer-open
                        :on-toggle   toggle-drawer}]

        [mui/typography {:component "h2" :color "inherit"
                         :style     {:flex "1"}}
         (str "Admin Mode für `"
              (get-in user [:name :first]) " "
              (get-in user [:name :last]) "`")
         [:br]
         [:span {:style {:fontSize "10px"}} (str "Build: " (subs build-date 0 16))]
         ]




        ; FIXME: replace with REST call and modal
        [:a {:href (str backend/BASE_URL "/help-page?page-name=" site) :target "_blank"}
         [mui/icon-button
          {:edge  "end" :aria-label "link"
           :style {:marginLeft "30px"}
           ;:onClick #(a/set-help (not (a/get-help)))
           }
          [help]
          ]]

        ;[connected-icon {:connected connected}]

        [mui/icon-button
         {:edge    "end" :class (:button classes) :aria-label "menu"
          :ref     set-anchor
          :onClick #(set-menu (. % -target))}
         [menu]
         ]
        [mui/menu {:anchorEl        @!menu-anchor
                   :transformOrigin {:vertical "bottom" :horizontal "right"}
                   :open            menu-open
                   :onClose         #(set-menu false)}

         (if (:tom-id user)
           (do
             [:f> logout-button {:onClose #(set-menu false)}])
           (do
             [mui/menu-item {:onClick (fn []
                                        (set-menu false)
                                        (a/set-no-back-page :landing))}
              "Login"]))

         ]
        ]
       ])))

(defn bar []
  (let [!menu-open (r/atom false)
        !actual-user (r/cursor vstate/app-state [:actual-user])
        !ws-connected (r/cursor vstate/app-state [:ws-connected])
        !drawer-menu (r/cursor vstate/app-state [:show-menu])
        !act-site (r/cursor vstate/app-state [:site])
        toggle-drawer #(reset! !drawer-menu (not @!drawer-menu))
        set-menu #(reset! !menu-open %)
        ]
    (fn [{:keys [classes]}]
      [_bar {:classes       classes
             :menu-open     @!menu-open
             :drawer-open   @!drawer-menu
             :user          @!actual-user
             :site          @!act-site
             :connected     @!ws-connected
             :toggle-drawer toggle-drawer
             :set-menu      set-menu}])))


;(swap! vstate/app-state assoc :site :login)